import {BasicCriteria} from '../../framework/parameters/BasicCriteria';

export class UserContextCriteria extends BasicCriteria {
login: string;
vision: string;
}

